import { ReducerAction } from '@keplerco/core';
import { ChatMessage } from '../../../overmind/actions/ai/ai-chat';
import { MessageChunk } from './chat.helpers';

export interface ChatState {
  messages: ChatMessage[];
  messageChunks: MessageChunk[];
  currentMessageIndex: number;
  isStreaming: boolean;
  error: string | undefined;
}

export const initialState: ChatState = {
  messages: [],
  messageChunks: [{ type: 'text', content: '', tool: undefined, input: undefined }],
  currentMessageIndex: 0,
  isStreaming: false,
  error: undefined,
};

// actions
export enum ChatActionTypes {
  AddMessage = 'ADD_MESSAGE',
  AddMessageChunk = 'ADD_MESSAGE_CHUNK',
  AddToken = 'ADD_TOKEN',
  SetIsStreaming = 'SET_IS_STREAMING',
  SetError = 'SET_ERROR',
}

type ChatAction =
  | ReducerAction<ChatActionTypes.AddMessage, { payload: ChatMessage }>
  | ReducerAction<ChatActionTypes.AddMessageChunk, { payload: MessageChunk }>
  | ReducerAction<ChatActionTypes.AddToken, { payload: string }>
  | ReducerAction<ChatActionTypes.SetIsStreaming, { payload: boolean }>
  | ReducerAction<ChatActionTypes.SetError, { payload: string | undefined }>;

// reducer
export function reducer(state: ChatState, action: ChatAction): ChatState {
  switch (action.type) {
    case ChatActionTypes.AddMessage: {
      return {
        ...state,
        messages: [...state.messages, action.payload as ChatMessage],
      };
    }

    case ChatActionTypes.AddMessageChunk: {
      const messageChunk = action.payload as MessageChunk;
      if (messageChunk.type === 'tool') {
        let currentMessageIndex = state.currentMessageIndex;
        currentMessageIndex++;
        return {
          ...state,
          currentMessageIndex: currentMessageIndex,
          messageChunks: [...state.messageChunks, action.payload as MessageChunk],
        };
      }
      return { ...state };
    }

    case ChatActionTypes.AddToken: {
      const updatedMessageChunks = [...state.messageChunks];
      let currentMessageIndex = state.currentMessageIndex;
      let messageChunk: MessageChunk;
      if (updatedMessageChunks[state.currentMessageIndex] && updatedMessageChunks[state.currentMessageIndex].type === 'text') {
        messageChunk = updatedMessageChunks[state.currentMessageIndex];
      } else {
        if (currentMessageIndex > 0) {
          currentMessageIndex++;
          updatedMessageChunks.push({ type: 'text', content: '', tool: undefined, input: undefined });
        }
        messageChunk = { type: 'text', content: '', tool: undefined, input: undefined };
        updatedMessageChunks[currentMessageIndex] = messageChunk;
      }
      messageChunk.content += action.payload as string;
      return {
        ...state,
        currentMessageIndex: currentMessageIndex,
        messageChunks: updatedMessageChunks,
      };
    }

    case ChatActionTypes.SetIsStreaming: {
      return {
        ...state,
        isStreaming: action.payload as boolean,
        // Reset message chunks and current tokens when starting streaming
        ...(action.payload ? { messageChunks: [], currentTokens: '' } : {}),
      };
    }

    case ChatActionTypes.SetError: {
      return {
        ...state,
        error: action.payload as string | undefined,
      };
    }

    default:
      return state;
  }
}
